module.exports = [{
      plugin: require('F:/Shared/www/riadchebbi/site/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-147522650-1"},
    },{
      plugin: require('F:/Shared/www/riadchebbi/site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
